import { __ } from '@wordpress/i18n';

export const Block = () => {
	return (
		<div className="wwp_requisition_list_block">
			<button style={{ width: '100%' }} type="button" id="requisition_add_to_list" class="button requisition_add_to_list" name="requisition_add_to_list">{ __( 'Save as Requisition List', 'woocommerce-wholesale-pricing' ) }</button>
		</div>
	);
};
